export class Extras {
	get dress(): Array<Object> {
		return this._dress;
	}

	set dress(value: Array<Object>) {
		this._dress = value;
	}

	get lightSource(): Object {
		return this._lightSource;
	}

	set lightSource(value: Object) {
		this._lightSource = value;
	}

	get extraDressingRoom(): number {
		return this._extraDressingRoom;
	}

	set extraDressingRoom(value: number) {
		this._extraDressingRoom = value;
	}

	get numberOfPersons(): number {
		return this._numberOfPersons;
	}

	set numberOfPersons(value: number) {
		this._numberOfPersons = value;
	}

	get bathFilling(): number {
		return this._bathFilling;
	}

	set bathFilling(value: number) {
		this._bathFilling = value;
	}

  constructor() {
    this._dress = null;
    this._lightSource = null;
    this._extraDressingRoom = null;
    this._numberOfPersons = null;
    this._bathFilling = null;
  }


	private _dress: Array<Object>;
	private _lightSource: Object;
	private _extraDressingRoom: number;
	private _numberOfPersons: number;
	private _bathFilling: number;


}
